module.exports = __webpack_public_path__ + "img/icon_card.13aa487b.png";